<template>
    <div v-if="formInput.visibility" class="position-relative row mb-3">
        <label class="form-label col-sm-2 col-form-label" :for="formInput.name">{{formInput.label}}</label>
        <div class="col-sm-10">
            <pv-checkbox
                    :id="formInput.name"
                    class="col-form-label"
                    :class="{'is-invalid': formInput.error, 'is-valid': formInput.validated}"
                    :disabled="formInput.disabled"
                    v-tooltip.top="formInput.tooltip"
                    v-model="checked"
                    :binary="true"/>
            <div v-if="formInput.error" class="invalid-feedback">
                <span v-if="formInput.errorCustom">{{formInput.customMessage}}</span>
                <span v-if="formInput.errorRequired">{{formInput.requiredMessage}}</span>
            </div>
            <small class="form-text text-muted" v-if="formInput.info">
                {{formInput.info}}
            </small>
        </div>
    </div>
</template>

<script>

    import CheckBox from 'primevue/checkbox';
    import Tooltip from 'primevue/tooltip';


    export default {
        props: ['formInput'],
        emits: ['changeValue'],
        components: {
            'pv-checkbox': CheckBox,
        },
        directives: {
            'tooltip': Tooltip
        },
        data() {
            return {
                checked: false
            }
        },
        created() {
            this.checked = this.formInput.value;
        },
        watch: {
            checked(newValue) {
                if (this.formInput) {
                    this.$emit('changeValue', {name: this.formInput.name, value: newValue})
                }
            },
            formInput: {
                handler() {
                    this.checked = this.formInput.value;
                },
                deep: true
            }

        }
    }
</script>